import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../shared/config";
import { useAuth } from "../contexts/AuthContext";
import { FAVORIS, findPage } from "./navConfig";

// Épingles (favoris) de l'utilisateur : user.epingles, sinon défauts par rôle. Résolues contre l'arbre filtré par droits.
export const useEpingles = (tree) => {
  const { user, setUser } = useAuth();
  const [saving, setSaving] = useState(false);
  const defaults = FAVORIS[user?.role] || [];
  const metaByKey = Object.fromEntries(defaults.map(d => [d.key, d]));
  const raw = user?.epingles?.length ? user.epingles.map(k => metaByKey[k] || { key: k }) : defaults;
  const keys = raw.map(r => r.key);
  const pins = raw.map(({ key, ...meta }) => {
    const [target, ecran] = key.split('#');
    const hit = findPage(tree, target);
    return hit ? { key, target, ecran, meta, ...hit } : null;
  }).filter(Boolean);

  const save = useCallback(async (next) => {
    setSaving(true);
    try {
      await axios.put(`${API}/users/me/epingles`, { epingles: next });
      setUser?.({ ...user, epingles: next });
    } catch { toast.error("Impossible d'enregistrer vos épingles"); }
    finally { setSaving(false); }
  }, [user, setUser]);

  const add = (key) => { if (keys.includes(key)) return; if (keys.length >= 8) { toast.info('8 épingles maximum'); return; } save([...keys, key]); };
  const remove = (key) => save(keys.filter(k => k !== key));
  return { pins, keys, add, remove, saving };
};
